"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentEmploymentStatus = void 0;
const enums_1 = require("@bemlo/enums");
exports.currentEmploymentStatus = {
    [enums_1.CurrentEmploymentStatus.EMPLOYED]: 'Employed',
    [enums_1.CurrentEmploymentStatus.UNDER_NOTICE]: 'Have given notice',
    [enums_1.CurrentEmploymentStatus.IN_STAFFING]: 'Works in staffing',
};
